import React from "react";
import styles from "./styles";
import multipleSelection from "../../../../images/multipleSelection.svg";
import correctIcon from "../../../../images/correct.svg";
import globeIcon from "../../../../images/globeIcon.svg";
import flagIcon from "../../../../images/flagIcon.svg";
import NotQuiteIcon from "../../../../images/notQuite.svg";
import IncorrectIcon from "../../../../images/incorrect.svg";
import { Grid, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import "animate.css/animate.css";
import { isMobile } from "react-device-detect";

const BreakingNews = ({
  questionAnswer,
  answeredCorrectly,
  answeredPartialy,
  submitted,
  questionIndex,
  classes,
}) => {
  return (
    <>
      <Grid style={{ display: submitted ? "none" : "block" }}>
        <Grid className={classes.questionContainer}>
          <Grid className={classes.questionHeader}>
            {questionAnswer.type === "international" ? (
              <img src={globeIcon} className={classes.headerIcon} alt=""></img>
            ) : (
              <img src={flagIcon} className={classes.headerIcon} alt=""></img>
            )}
            <Typography
              varient="h5"
              className={`${classes.headerText} ${
                (questionIndex === 3 || questionIndex === 10) &&
                "animate__animated animate__bounceIn"
              }`}
            >
              {isMobile ? questionAnswer.mobileHeader : questionAnswer.header}
            </Typography>
          </Grid>

          <Grid className={classes.questionBody}>
            <img
              src={questionAnswer.icon}
              className={classes.circleIcon}
              alt=""
            />
            <Grid style={{ display: submitted ? "none" : "block" }}>
              <Typography
                className={
                  questionAnswer.type === "international" ||
                  questionAnswer.type === "international2"
                    ? classes.internationalQuestionDescription
                    : classes.domesticQuestionDescription
                }
                dangerouslySetInnerHTML={{ __html: questionAnswer.text }}
              ></Typography>
            </Grid>
            {/* <Grid style={{ display: submitted ? "block" : "none" }}>
              <Typography
                className={
                  questionAnswer.type === "international"
                    ? classes.internationalQuestionDescription
                    : classes.domesticQuestionDescription
                }
                style={{ paddingTop: 15, color: "#7c7c7c" }}
              >
                {questionAnswer.answerTextTop}
              </Typography>
              <Typography
                className={
                  questionAnswer.type === "international"
                    ? classes.internationalQuestionDescription
                    : classes.domesticQuestionDescription
                }
                style={{ color: "#7c7c7c" }}
              >
                Select the {questionAnswer.question} area on the graph.
              </Typography>
            </Grid> */}

            <Grid
              style={{ display: submitted ? "none" : "block" }}
              className={classes.questionTextDiv}
            >
              <Typography
                variant="h5"
                className={`${classes.questionText} animate__animated animate__bounceIn`}
                style={{ fontWeight: 600, color: "#00b1d9" }}
              >
                Select the
              </Typography>
              <Typography
                variant="h5"
                className={`${classes.questionTextMajor} animate__animated animate__bounceIn`}
              >
                {questionAnswer.question}
              </Typography>
              <Typography
                variant="h5"
                className={`${classes.questionText} animate__animated animate__bounceIn`}
                style={{ fontWeight: 600, color: "#00b1d9" }}
              >
                area on the graph
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <img
          src={multipleSelection}
          className={classes.breakingNews}
          alt=""
        ></img>
      </Grid>

      <Grid
        className={classes.answerContainer}
        style={{ display: submitted ? "block" : "none" }}
      >
        <Grid>
          <Grid className={classes.questionBody}>
            <Grid>
              <Typography className={classes.answerDescription}>
                {questionAnswer.answerTextTop}
              </Typography>
              <Typography className={classes.answerDescription}>
                Select the {questionAnswer.question} area on the graph.
              </Typography>
            </Grid>

            {answeredCorrectly ? (
              <img
                src={correctIcon}
                className={classes.correctIncorrectIcon}
                alt=""
              />
            ) : answeredPartialy ? (
              <>
                <img
                  src={NotQuiteIcon}
                  className={classes.correctIncorrectIcon}
                  alt=""
                />

                <Typography variant="h4" className={classes.noQuiteText}>
                  {questionAnswer.notQuiteText}
                </Typography>
              </>
            ) : (
              answeredCorrectly === false && (
                <img
                  src={IncorrectIcon}
                  className={classes.correctIncorrectIcon}
                  // style={{ fontSize: 22, marginTop: 25, marginBottom: 25 }}
                  alt=""
                />
              )
            )}
            <Typography variant="h4" className={classes.answerText}>
              {questionAnswer.answerText}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default withStyles(styles)(BreakingNews);
